import React, { useEffect, useState } from 'react'
import { Avatar, Button, Card, Col, Icons, Row } from '@pankod/refine-antd'

import { useTranslate, useGetIdentity, useList, useTable } from '@pankod/refine-core'

import './style.less'

import { IPaper, IPaperRequest, IQuestion, ITestEvent } from 'interfaces'
import dayjs, { Dayjs } from 'dayjs'
import {
  getWorkRequestCount,
  getQuestionCount,
  getPaperCount,
  getPaperRequestCount,
  getPaperTemplateCount,
  getEvaluationRequestDetailsByUser,
  getEvaluationRequestDetailsByUserStatus,
} from 'gql/query'
import { useUserContext } from 'context/user'
// import DashBoardChart from 'components/chart/Chart'
const { QuestionOutlined, ExceptionOutlined, ProjectOutlined, LikeOutlined, UserOutlined, RightCircleOutlined } = Icons

const { Meta } = Card

export const PaperUsersDashboard: React.FC = () => {
  const { data: user } = useGetIdentity()
  const role = user?.defaultRole
  const t = useTranslate()
  let now = dayjs()

  const { changeUser, userRole } = useUserContext()

  const [paperRequestCount, setPaperRequestCount] = useState<any>(0)
  const [paperPendingCount, setPaperPendingCount] = useState<any>(0)

  const [openPaperRequest, setOpenPaperRequest] = useState<any>(0)
  const [closedPaperRequest, setClosedPaperRequest] = useState<any>(0)
  const [openPapers, setOpenPapers] = useState<any>(0)
  const [closedPapers, setClosedPapers] = useState<any>(0)
  const [paperTemplates, setPaperTemplates] = useState<any>(0)

  const { tableQueryResult: testEventQueryData } = useTable<ITestEvent>({ resource: 'test_events', metaData: { fields: ['id'] } })
  console.log(testEventQueryData?.data)

  // useEffect(() => {
  //   changeUser(user?.defaultRole)
  // }, [user])

  // Paper stats
  const {
    tableQueryResult: paperRequestsList,
    filters: paperRequestsFilters,
    setFilters: setPaperRequestsFilter,
  } = useTable<IPaperRequest>({
    resource: 'paper_requests',
    initialFilter: [
      {
        field: 'created_at',
        operator: 'lte',
        value: dayjs().endOf('month').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      },
      {
        field: 'created_at',
        operator: 'gte',
        value: dayjs().startOf('month').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      },
    ],
    metaData: {
      fields: ['id', 'status', 'created_at'],
    },
  })

  const {
    tableQueryResult: paperPendingList,
    filters: paperPendingFilters,
    setFilters: setPaperPendingFilter,
  } = useTable<IPaper>({
    resource: 'papers',
    initialFilter: [
      {
        field: 'created_at',
        operator: 'lte',
        value: dayjs().endOf('month').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      },
      {
        field: 'created_at',
        operator: 'gte',
        value: dayjs().startOf('month').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      },
      {
        field: 'status',
        operator: 'ne',
        value: 'Approved',
      },
      {
        field: 'status',
        operator: 'ne',
        value: 'For Approval',
      },
    ],
    metaData: {
      fields: ['id', 'status'],
    },
  })

  useEffect(() => {
    if (paperPendingList?.data?.data) {
      setPaperPendingCount(paperPendingList?.data?.total)
    }
  }, [paperPendingList?.data])

  useEffect(() => {
    if (paperRequestsList?.data?.data) {
      setPaperRequestCount(paperRequestsList?.data?.total)
    }
  }, [paperRequestsList?.data])

  useEffect(() => {
    let paperClosedListFilter: object[] = []
    let paperOpenListFilter: object[] = []
    let paperRequestClosedListFilter: object[] = []
    let paperRequestOpenListFilter: object[] = []
    let paperTemplateListFilter: object[] = []

    if (userRole === 'productmanager' || userRole === 'deliverymanager' || userRole === 'papersetter' || userRole === 'paperapprover') {
      if (userRole === 'productmanager') {
        // arrFilter.push({field:"created_by", operator:"_eq", value:user?.id})
        // arrFilter.push({field:"status", operator:"_eq", value:"closed"})

        // paperRequestClosedListFilter.push(
        //   { field: 'created_by', operator: '_eq', value: user?.id },
        //   { field: 'status', operator: '_eq', value: 'open' }
        // )
        paperRequestClosedListFilter.push(
          { created_by: { _eq: user?.id } },
          { _or: [{ status: { _eq: 'Completed' } }, { status: { _eq: 'Closed' } }] }
        )
        // paperRequestOpenListFilter.push(
        //   { field: 'created_by', operator: '_eq', value: user?.id },
        //   { field: 'status', operator: '_eq', value: 'open' }
        // )

        paperRequestOpenListFilter.push({ created_by: { _eq: user?.id } }, { _or: [{ status: { _eq: 'Open' } }, { status: { _eq: 'In Progress' } }] })

        // paperTemplateListFilter.push({ field: 'created_by', operator: '_eq', value: user?.id })
        paperTemplateListFilter.push({ created_by: { _eq: user?.id } })
      }

      if (userRole === 'papersetter') {
        // paperOpenListFilter.push({ field: 'created_by', operator: '_eq', value: user?.id }, { field: 'status', operator: '_neq', value: 'Approved' })
        paperOpenListFilter.push({ created_by: { _eq: user?.id } }, { status: { _neq: 'Approved' } })
        // paperClosedListFilter.push({ field: 'created_by', operator: '_eq', value: user?.id }, { field: 'status', operator: '_eq', value: 'Approved' })
        paperClosedListFilter.push({ created_by: { _eq: user?.id } }, { status: { _eq: 'Approved' } })
        paperRequestOpenListFilter.push(
          { paper_setter_id: { _eq: user?.id } },
          { _or: [{ status: { _eq: 'Open' } }, { status: { _eq: 'In Progress' } }] }
        )
        paperRequestClosedListFilter.push(
          { paper_setter_id: { _eq: user?.id } },
          { _or: [{ status: { _eq: 'Completed' } }, { status: { _eq: 'Closed' } }] }
        )
      }

      if (userRole === 'paperapprover') {
        paperOpenListFilter.push({ paper_approver_id: { _eq: user?.id } }, { status: { _neq: 'Approved' } })
        paperClosedListFilter.push({ paper_approver_id: { _eq: user?.id } }, { status: { _eq: 'Approved' } })
        // paperRequestClosedListFilter.push({ field: 'paper_approver_id', operator: '_eq', value: user?.id })
        paperRequestClosedListFilter.push(
          { paper_approver_id: { _eq: user?.id } },
          { _or: [{ status: { _eq: 'Completed' } }, { status: { _eq: 'Closed' } }] }
        )
        // paperRequestOpenListFilter.push({ field: 'paper_approver_id', operator: '_eq', value: 'open' })
        paperRequestOpenListFilter.push(
          { paper_approver_id: { _eq: user?.id } },
          { _or: [{ status: { _eq: 'Open' } }, { status: { _eq: 'In Progress' } }] }
        )
      }
      if (userRole === 'deliverymanager') {
        //show test event list for now
      }
      // let paperCloseCondition = ''
      // let paperOpenCondition = ''
      // let paperRequestCloseCondition = ''
      // let paperRequestOpenCondition = ''
      // let paperTemplateCondition = ''

      // paperClosedListFilter.length > 0 &&
      //   paperClosedListFilter.forEach((element: any) => {
      //     if (element.field !== undefined && element.field !== null && element.field !== '') {
      //       let text = ''
      //       text = `papers:{${element.field}:${element.operator}:${element.value}}`

      //       paperCloseCondition.concat(text)
      //     }
      //   })
      // paperOpenListFilter.length > 0 &&
      //   paperOpenListFilter.forEach((element: any) => {
      //     if (element.field !== undefined && element.field !== null && element.field !== '') {
      //       let text = ''
      //       text = `papers:{${element.field}:${element.operator}:${element.value}}`
      //       paperOpenCondition.concat(text)
      //     }
      //   })
      // paperRequestClosedListFilter.length > 0 &&
      //   paperRequestClosedListFilter.forEach((element: any) => {
      //     if (element.field !== undefined && element.field !== null && element.field !== '') {
      //       let text = ''
      //       text = `${element.field}:{${element.operator}:"${element.value}"},`

      //       paperRequestCloseCondition.concat(text)
      //     }
      //   })
      // paperRequestOpenListFilter.length > 0 &&
      //   paperRequestOpenListFilter.forEach((element: any) => {
      //     if (element.field !== undefined && element.field !== null && element.field !== '') {
      //       let text = ''
      //       text = `papers:{${element.field}:${element.operator}:${element.value}}`
      //       paperRequestOpenCondition.concat(text)
      //     }
      //   })
      // paperTemplateListFilter.length > 0 &&
      //   paperTemplateListFilter.forEach((element: any) => {
      //     if (element.field !== undefined && element.field !== null && element.field !== '') {
      //       let text = ''
      //       text = `papers:{${element.field}:${element.operator}:${element.value}}`
      //       paperTemplateCondition.concat(text)
      //     }
      //   })
      // console.log(paperRequestCloseCondition, paperRequestClosedListFilter, 'PRCLOSE')

      getPaperCount({ _and: paperClosedListFilter }).then((resp: any) => setClosedPapers(resp?.papers_aggregate?.aggregate?.count))
      getPaperCount({ _and: paperOpenListFilter }).then((resp: any) => setOpenPapers(resp?.papers_aggregate?.aggregate?.count))
      getPaperRequestCount({ _and: paperRequestClosedListFilter }).then((resp: any) =>
        setClosedPaperRequest(resp?.paper_requests_aggregate?.aggregate?.count)
      )
      getPaperRequestCount({ _and: paperRequestOpenListFilter }).then((resp: any) =>
        setOpenPaperRequest(resp?.paper_requests_aggregate?.aggregate?.count)
      )
      getPaperTemplateCount({ _and: paperTemplateListFilter }).then((resp: any) =>
        setPaperTemplates(resp?.paper_templates_aggregate?.aggregate?.count)
      )
    }
  }, [userRole])
  const [total, setTotal] = useState(0)
  const [completd, setCompleted] = useState(0)
  useEffect(() => {
    if (userRole === 'deliverymanager') {
      getEvaluationRequestDetailsByUser(user?.id, userRole).then((resp: any) => {
        // console.log({ resp })
        setTotal(resp?.evaluation_requests_aggregate?.aggregate?.count)
      })
      getEvaluationRequestDetailsByUserStatus(user?.id, userRole).then((resp: any) => {
        // console.log({ resp })
        setCompleted(resp?.evaluation_requests_aggregate?.aggregate?.count)
      })
    }
  }, [userRole, user])

  return (
    <div className="">
      <>
        <Row gutter={16} className="mt-3">
          {userRole === 'productmanager' || userRole === 'paperapprover' || userRole === 'papersetter' ? (
            <>
              {' '}
              <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
                <div className="dashboard-card1">
                  <Row className="card-content">
                    <Col md={18} className="text-container">
                      <h4>Closed Paper Requests</h4>
                      <h3 style={{ margin: '0' }}>{closedPaperRequest}</h3>
                    </Col>
                    <Col md={6} className="icon-container">
                      <ProjectOutlined className="icon" />
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
                <div className="dashboard-card1">
                  <Row className="card-content">
                    <Col md={18} className="text-container">
                      <h4> Pending Paper Requests </h4>
                      <h3 style={{ margin: '0' }}>{openPaperRequest}</h3>
                    </Col>
                    <Col md={6} className="icon-container">
                      <ProjectOutlined className="icon" />
                    </Col>
                  </Row>
                </div>
              </Col>
            </>
          ) : null}

          {userRole === 'papersetter' || userRole === 'paperapprover' ? (
            <>
              {' '}
              <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
                <div className="dashboard-card1">
                  <Row className="card-content">
                    <Col md={18} className="text-container">
                      <h4> Pending Papers</h4>
                      <h3 style={{ margin: '0' }}>{openPapers}</h3>
                    </Col>
                    <Col md={6} className="icon-container">
                      <ExceptionOutlined className="icon" />
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
                <div className="dashboard-card1">
                  <Row className="card-content">
                    <Col md={18} className="text-container">
                      <h4> Approved Papers</h4>
                      <h3 style={{ margin: '0' }}>{closedPapers}</h3>
                    </Col>
                    <Col md={6} className="icon-container">
                      <ExceptionOutlined className="icon" />
                    </Col>
                  </Row>
                </div>
              </Col>
            </>
          ) : null}
          {userRole === 'productmanager' ? (
            <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
              <div className="dashboard-card1">
                <Row className="card-content">
                  <Col md={18} className="text-container">
                    <h4> Paper Templates</h4>
                    <h3 style={{ margin: '0' }}>{paperTemplates}</h3>
                  </Col>
                  <Col md={6} className="icon-container">
                    <ExceptionOutlined className="icon" />
                  </Col>
                </Row>
              </div>
            </Col>
          ) : null}
          {userRole === 'productmanager' || userRole === 'deliverymanager' ? (
            <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
              <div className="dashboard-card1">
                <Row className="card-content">
                  <Col md={18} className="text-container">
                    <h4> Total Test Events</h4>
                    <h3 style={{ margin: '0' }}>{testEventQueryData?.data && testEventQueryData?.data?.total}</h3>
                  </Col>
                  <Col md={6} className="icon-container">
                    <ExceptionOutlined className="icon" />
                  </Col>
                </Row>
              </div>
            </Col>
          ) : null}
          {userRole === 'deliverymanager' ? (
            <>
              <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
                <div className="dashboard-card1">
                  <Row className="card-content">
                    <Col md={18} className="text-container">
                      <h4>Evaluation Requests</h4>
                      <h3 style={{ margin: '0' }}>{total}</h3>
                    </Col>
                    <Col md={6} className="icon-container">
                      <ProjectOutlined className="icon" />
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
                <div className="dashboard-card1">
                  <Row className="card-content">
                    <Col md={18} className="text-container">
                      <h4> Completed Requests </h4>
                      <h3 style={{ margin: '0' }}>{completd}</h3>
                    </Col>
                    <Col md={6} className="icon-container">
                      <ProjectOutlined className="icon" />
                    </Col>
                  </Row>
                </div>
              </Col>
            </>
          ) : null}
        </Row>
      </>
      {/* {breakpoint.md && (
        <div style={{ marginTop: '4rem' }}>
          <DashBoardChart details={details} label={label} />
        </div>
      )} */}
    </div>
  )
}
